import { BaseColumnSchemaPart, PosixDateTransformer, } from "@for-it/domain-lib";
import { EntitySchema } from "typeorm";
export const StatusType = {
    PENDING: "PENDING",
    APPROVED: "APPROVED",
    REJECTED: "REJECTED",
};
export const CertificationEntity = new EntitySchema({
    name: "certifications",
    columns: {
        ...BaseColumnSchemaPart,
        title: {
            type: "varchar",
        },
        summary: {
            type: "text",
            nullable: true,
        },
        from: {
            type: "varchar",
        },
        externalUrl: {
            type: "varchar",
        },
        companyId: {
            type: "uuid",
        },
        status: {
            type: "varchar",
            enum: StatusType,
            default: StatusType.PENDING,
        },
        approvedAt: {
            type: "date",
            nullable: true,
            transformer: PosixDateTransformer,
        },
    },
    relations: {
        company: {
            type: "many-to-one",
            target: "companies",
            joinColumn: {
                name: "companyId",
            },
            cascade: true,
        },
        certificationUsers: {
            type: "one-to-many",
            target: "certification_users",
            inverseSide: "cert",
            joinColumn: {
                name: "certificationId",
            },
        },
    },
});
